import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TreeView from '@Services/TreeView';
import Button from '@Components/Button';
import allowedTags from '@Services/AllowedTag';
import { ALLOWED_TAGS_ARRAY } from '../TreeViewConstants';

import './TreeViewSelected.custom.scss';
import './TreeViewSelected.theme.scss';

const CONTAINER_SELECTOR = 'treeViewSelected-container';

function TreeViewSelected({ selectedTaxonomies, selectedCustomItems, selectedListExpanded, onToggle, onRemove }) {
  const [isMoreVisible, setIsMoreVisible] = useState(false);

  function getIsMoreVisible() {
    const container = document.getElementById(CONTAINER_SELECTOR);

    if (!container) {
      return false;
    }

    const containerWidth = container.offsetWidth;

    const isWidthAcceptable = TreeView.isElementsWidthMoreThenMaximal(container.children, containerWidth);

    return selectedListExpanded || isWidthAcceptable;
  }

  useEffect(() => {
    if (selectedTaxonomies || selectedCustomItems) {
      setIsMoreVisible(getIsMoreVisible());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTaxonomies, selectedCustomItems]);

  const toggleExpanded = () => {
    onToggle(!selectedListExpanded);
  };

  const getAllowedTags = (value) => {
    return allowedTags(value, ALLOWED_TAGS_ARRAY);
  };

  const getMoreIcon = () => {
    return selectedListExpanded ? 'minus' : 'plus';
  };

  return (
    <div
      className={classnames('treeViewSelected', {
        'treeViewSelected-expanded': selectedListExpanded,
      })}>
      <div className="treeViewSelected__title">
        <h4 className="typography-small">Selected search items:</h4>
        {isMoreVisible && (
          <Button
            type="button"
            onClick={toggleExpanded}
            buttonConfig={{
              label: selectedListExpanded ? 'Less' : 'More',
              type: 'link',
              size: 'xs',
              e2eName: 'tree-view-selected-showMore',
              iconOnly: true,
            }}
            iconConfig={{
              name: getMoreIcon(),
            }}
          />
        )}
      </div>
      <ul id="treeViewSelected-container" className="treeViewSelected__list">
        {selectedTaxonomies.map((taxonomy) => {
          return (
            <li className="treeViewSelected__list_item" key={`selected-taxonomies-${taxonomy.id}`}>
              <div className="treeViewSelected__list_item_label" title={taxonomy.name}>
                <span className="treeViewSelected__list_item_label_head">{getAllowedTags(taxonomy.label.first)}</span>
                <span className="treeViewSelected__list_item_label_tail">{getAllowedTags(taxonomy.label.last)}</span>
              </div>
              <Button
                type="button"
                onClick={() => onRemove(taxonomy)}
                buttonConfig={{
                  type: 'link',
                  size: 'xs',
                  e2eName: 'tree-view-selected-item-remove',
                  iconOnly: true,
                }}
                iconConfig={{
                  name: 'delete',
                }}
              />
            </li>
          );
        })}

        {/* eslint-disable-next-line react/prop-types */}
        {selectedCustomItems.map((custom, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <li className="treeViewSelected__list_item" key={`selected-taxonomies-${custom}-${index}`}>
              <div className="treeViewSelected__list_item_label" title={custom}>
                <span className="treeViewSelected__list_item_label_head" title={custom}>
                  {getAllowedTags(custom)}
                </span>
              </div>
              <Button
                type="button"
                onClick={() => onRemove({ value: custom, index, custom: true })}
                buttonConfig={{
                  type: 'link',
                  size: 'xs',
                  e2eName: 'tree-view-selected-item-remove',
                  iconOnly: true,
                }}
                iconConfig={{
                  name: 'delete',
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

TreeViewSelected.propTypes = {
  selectedTaxonomies: PropTypes.array,
  selectedCustomItems: PropTypes.array,
  selectedListExpanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default TreeViewSelected;
